import { render } from "./WaveCard.vue?vue&type=template&id=c0b75602&scoped=true"
import script from "./WaveCard.vue?vue&type=script&lang=js"
export * from "./WaveCard.vue?vue&type=script&lang=js"

import "./WaveCard.vue?vue&type=style&index=0&id=c0b75602&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0b75602"]])

export default __exports__